import { useEffect, useRef } from "react";

/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt1@ghtk.vn on 11/08/2020.
 * @module ADMIN CONSTANTS
 */
const createBreadActionConstants = (moduleName, actionNameSuffix) => {
  return {
    browse: `${moduleName}/BROWSE/${actionNameSuffix}`,
    read: `${moduleName}/READ/${actionNameSuffix}`,
    edit: `${moduleName}/EDIT/${actionNameSuffix}`,
    add: `${moduleName}/ADD/${actionNameSuffix}`,
    delete: `${moduleName}/DELETE/${actionNameSuffix}`
  };
};
// // Action constants
export const MODULE_NAME = "ADMIN";

export const serverBread = createBreadActionConstants(MODULE_NAME, "SERVER");
export const BROWSE_JOB_VIDEO_STATUS = `${MODULE_NAME}/BROWSE_JOB_VIDEO_STATUS`;
export const userPermission = createBreadActionConstants(
  MODULE_NAME,
  "USER_PERMISSION"
);
export const adminBrowseStation = createBreadActionConstants(
  MODULE_NAME,
  "LIST_STATION"
);
export const cameraSetting = createBreadActionConstants(
  MODULE_NAME,
  "CAMERA_SETTING"
);

export const CONNECTION_TYPE = {
  0: {
    id: "0",
    name: "Local"
  },
  1: {
    id: "1",
    name: "Public"
  }
};
export const DVR_STATUS_FOR_FILTER = {
  1: {
    id: "1",
    name: "Online",
    color: "#069255"
  },
  "-103": {
    id: "-103",
    name: "Offline",
    color: "#000"
  },
  0: {
    id: "0",
    name: "Disconnect",
    color: "#b5b5c3"
  }
};
export const DVR_STATUS = {
  1: {
    id: "1",
    name: "Online"
  },
  0: {
    id: "0",
    name: "Init"
  },
  "-1": {
    id: "-1",
    name: "Invalid user/pass"
  },
  "-2": {
    id: "-2",
    name: "Username not found"
  },
  "-3": {
    id: "-3",
    name: "Timeout"
  },
  "-4": {
    id: "-4",
    name: "Repeat login"
  },
  "-5": {
    id: "-5",
    name: "Account is locked"
  },
  "-6": {
    id: "-6",
    name: "Account is blacklisted"
  },
  "-7": {
    id: "-7",
    name: "Insufficient resources"
  },
  "-8": {
    id: "-8",
    name: "Child connection failed"
  },
  "-9": {
    id: "-9",
    name: "Main connection failed"
  },
  "-10": {
    id: "-10",
    name: "Max connections exceeded"
  },
  "-11": {
    id: "-11",
    name: "Only support 3rd protocol"
  },
  "-12": {
    id: "-12",
    name: "Invalid USB shield"
  },
  "-13": {
    id: "-13",
    name: "No permission IP"
  },
  "-18": {
    id: "-18",
    name: "Account not initialized"
  },
  "-100": {
    id: "-100",
    name: "Other error"
  },
  "-101": {
    id: "-101",
    name: "Exception login SDK"
  },
  "-102": {
    id: "-102",
    name: "Login http failed"
  },
  "-103": {
    id: "-103",
    name: "Inactive"
  }
};
export const PAGINATION = {
  limit: 20,
  offset: 1
};

export const STATION_STATUS = {
  0: {
    id: "0",
    name: "Khởi tạo"
  },
  1: {
    id: "1",
    name: "Có thông tin đầu thu(DVR)"
  },
  2: {
    id: "2",
    name: "Đã cấu hình"
  },
  3: {
    id: "3",
    name: "Có video"
  }
};

export const STATION_TYPE = {
  parking: {
    id: "parking",
    name: "Bãi Đỗ Xe"
  },
  post_office: {
    id: "post_office",
    name: "Bưu cục"
  },
  station: {
    id: "station",
    name: "Kho"
  }
};

export const DATA_TYPE = ["Array", "Number", "JSON", "String"];

export const DVR_CONNECT_TYPE = {
  PUBLIC: 1,
  LOCAL: 0
};

export const DVR_STATUS_TRUCK = {
  1: {
    id: "1",
    name: "Online"
  },
  0: {
    id: "0",
    name: "Offline"
  }
};

export const CHANNEL_MANAGE_DVR_STATUS = {
  1: {
    id: "1",
    name: "Online"
  },
  0: {
    id: "0",
    name: "Offline"
  },
  "-1": {
    id: "-1",
    name: "Offline"
  },
  "-2": {
    id: "-2",
    name: "Offline"
  }
};
export const SMARTLOCK_STATUS_FOR_FILTER = {
  ONLINE: {
    name: "Online",
    value: "ONLINE",
    color: "#069255"
  },
  DISCONNECT: {
    name: "Disconnect",
    value: "DISCONNECT",
    color: "#b5b5c3"
  },
  OFFLINE: {
    name: "Offline",
    value: "OFFLINE",
    color: "#ff0000"
  }
};

export const SMARTLOCK_TYPE = {
  NORMAL: {
    name: "Tủ thường",
    value: "NORMAL"
  },
  BUYER: {
    name: "Tủ buyer",
    value: "BUYER"
  },
  OTP: {
    name: "Tủ VTV",
    value: "OTP"
  },
  OFFICE: {
    "name": "Tủ hành chính",
    "value": "OFFICE"
  }
};

export const PROCESS_TIME = {
  level1: 3600,
  level2: 86400,
  level3: 259200
};

export const INCIDENT_STATUS = [
  {
    label: "Báo lỗi",
    value: 0
  },
  {
    label: "Tiếp nhận",
    value: 10
  },
  {
    label: "Chờ xử lý",
    value: 20
  }
  // {
  //   label: "Hoàn thành",
  //   value: 30
  // }
];

export const TAG_STATUS_COLOR = {
  0: {
    color: "#FF2A04",
    label: "New"
  },
  10: {
    color: "#FFAF3D",
    label: "Tiếp nhận"
  },
  20: {
    color: "#FAD800",
    label: "Chờ xử lý"
  },
  30: {
    color: "#00904A",
    label: "Hoàn thành"
  },
  98: {
    color: "#DA5149",
    label: "Urgent"
  },
  99: {
    color: "#FD0000",
    label: "Quá hạn"
  }
};

export const STATUS_TITLE = {
  10: "Tiếp nhận",
  20: "Chờ xử lý",
  30: "Hoàn thành"
};

export const FILTER_TAG_NAME = {
  CAMERA_TRUCK: "Cam xe tải",
  CAMERA_STATION: "Cam kho",
  SCALE: "Trụ bưu cục",
  GPS: "GPS",
  SMART_LOCK: "Tủ Smart Lock",
  CONVEYOR: "Lego",
  CROSSBELT: "Crossbelt - Bombay",
  // MODULE_SORTING: "Put To Light",
  MODULE_SORTING_FIRMWARE: "Put To Light",
  PRINTER: "Máy in",
  // SCANNER: "Máy quét",
  // STATION_DVR: "Camera kho",
  WHEEL_SORTER: "Wheel Sorter",
  TELESCOPIC: "Telescopic",
  FLASH_SCANNER: "Flash Scanner",
  // "TRIPOD" :"Tripod",
  BARRIER: "Barrier"
  // "MOBILE" :"MOBILE",
  // "NETWORK_EQUIPMENT" :"Thiết bị mạng",
  // "TABLET" :"TABLET",
  // "CAR" :"CAR",
  // "MOTOBIKE" :"MOTOBIKE",
};

export const DEVICE_SELECTS = [
  {
    label: "Cam xe tải",
    value: "CAMERA_TRUCK"
  },
  {
    label: "Cam kho",
    value: "CAMERA_STATION"
  },
  {
    label: "Trụ bưu cục",
    value: "SCALE"
  },
  {
    label: "GPS",
    value: "GPS"
  },
  {
    label: "Tủ smart lock",
    value: "SMART_LOCK"
  },
  {
    label: "Lego",
    value: "CONVEYOR"
  },
  {
    label: "Crossbelt",
    value: "CROSSBELT"
  },
  {
    label: "Bombay",
    value: "BOMBAY"
  },
  { label: "Module Sorting Firmware", value: "MODULE_SORTING_FIRMWARE" },
  { label: "Module Sorting", value: "MODULE_SORTING" },
  {
    label: "Máy in",
    value: "PRINTER"
  },
  {
    label: "Wheel Sorter",
    value: "WHEEL_SORTER"
  },
  {
    label: "Telescopic",
    value: "TELESCOPIC"
  },
  {
    label: "Flash Scanner",
    value: "FLASH_SCANNER"
  },
  { labe: "Barrier", value: "BARRIER" }
];

export const CAMERA_TYPE_NAME = {
  default: "Cam",
  CABIN: "Cam Cabin",
  CAM_THUNG: "Cam Thùng"
};

export const CAMERA_STATUS_NAME = {
  ONLINE: "success",
  OFFLINE: "error",
  PENDING: "default"
};

export const DEVICE_STATUS = [
  {
    label: "Online",
    value: "ONLINE"
  },
  {
    label: "Offline",
    value: "OFFLINE"
  }
];

export const TEMP_DEVICES_STATUS = ["CAMERA_TRUCK"];

export const IMPACT_LEVEL = [
  "Không ảnh hưởng đến vận hành",
  "Ảnh hưởng vận hành trong 2 giờ",
  "Ảnh hưởng vận hành trong 3 giờ",
  "Ảnh hưởng vận hành trong 4 giờ",
  "Ảnh hưởng vận hành trong 8 giờ",
  "Ảnh hưởng vận hành trong 12 giờ",
  "Ảnh hưởng vận hành trong 16 giờ",
  "Ảnh hưởng vận hành trong 24 giờ"
];

export const DEVICE_P2L = ["MODULE_SORTING_FIRMWARE", "MODULE_SORTING"];

export const DEVICE_LEGO = ["CONVEYOR", "LEGO_CHUTE", "CABINET"];

export const DEVICE_CROSSBELT = [
  "BOMBAY",
  "CROSSBELT",
  "ARM_SORTER",
  "OTHER_SORTING"
];

export const DEVICE_WHEEL_SORTER = [
  "CONVEYOR_WHEEL",
  "TU_DIEN_WHEEL",
  "MANG_CHIA_WHEEL",
  "BALANCE_WHEEL",
  "SCANNER_WHEEL",
  "WHEEL_SORTER"
];

export const DEVICE_SORTING = ["TELESCOPIC", "FLASH_SCANNER"];

export const LEGO_ERROR = [
  {
    value: "Điện - WMS - WCS - Động cơ - Biến tần",
    label: "Điện - WMS - WCS - Động cơ - Biến tần"
  },
  {
    value: "Cơ khí",
    label: "Cơ khí"
  },
  {
    value: "Các lỗi khác",
    label: "Các lỗi khác"
  }
];

export const LEGO_ERROR_TYPE = [
  {
    value: "Điện - WMS - WCS - Động cơ - Biến tần",
    children: ["Động cơ - biến tần", "Scanner", "Tủ điện"]
  },
  {
    value: "Cơ khí",
    children: [
      "Gối ổ",
      "Thành chắn, khung băng tải",
      "Con lăn",
      "Tang ép - Tang đầu",
      "Nhông",
      "Xích",
      "Các lỗi liên quan Belt"
    ]
  },
  {
    value: "Các lỗi khác",
    children: ["Chi tiết khác"]
  }
];

export const LEGO_ERROR_SPECIFIC = [
  {
    value: "Động cơ - biến tần",
    children: [
      "Hỏng hộp giảm tốc",
      "Rỉ dầu, kêu",
      "Hỏng - cháy động cơ",
      "Tăng chỉnh độ trùng",
      "Hỏng cháy biến tần",
      "Hỏng then"
    ]
  },
  {
    value: "Scanner",
    children: ["Không hoạt động", "Mất mạng"]
  },
  {
    value: "Tủ điện",
    children: [
      "Dây dẫn",
      "Hỏng đèn cảnh báo",
      "Hỏng nút bấm",
      "Hỏng thiết bị trong tủ điện"
    ]
  },
  {
    value: "Gối ổ",
    children: ["Gối ổ kêu - khô dầu", "Hỏng gối ổ"]
  },
  {
    value: "Thành chắn, khung băng tải",
    children: [
      "Hỏng chân",
      "Bung thành chắn",
      "Hỏng khung",
      "Bung mối hàn",
      "Bung thanh gia cố"
    ]
  },
  {
    value: "Con lăn",
    children: ["Lăn Hỏng", "Lăn Kêu"]
  },
  {
    value: "Tang ép - Tang đầu",
    children: [
      "Hỏng thân tang",
      "Hỏng cụm tăng chỉnh",
      "Hỏng trục",
      "Hỏng vòng bi"
    ]
  },
  {
    value: "Nhông",
    children: ["Nhông hỏng", "Mòn nhông", "Tụt then"]
  },
  {
    value: "Xích",
    children: ["Xích trùng", "Tuột xích", "Xích đứt", "Khô mỡ"]
  },
  {
    value: "Các lỗi liên quan Belt",
    children: [
      "Rách Belt",
      "Hỏng mối nối",
      "Lệch/trùng belt",
      "Tấm Pom bung ra, cong, vênh",
      "Mất, hỏng Pom"
    ]
  },
  {
    value: "Chi tiết khác",
    children: ["Quá tải", "Điện kho", "Dừng khẩn cấp", "Kẹt hàng"]
  }
];

export const LEGO_ERROR_DETAIL = [
  {
    value: "Hỏng hộp giảm tốc",
    children: ["Thay HGT"]
  },
  {
    value: "Hỏng - cháy động cơ",
    children: ["Thay động cơ"]
  },
  {
    value: "Hỏng cháy biến tần",
    children: ["Thay biến tần"]
  },
  {
    value: "Hỏng then",
    children: ["Thay then"]
  },
  {
    value: "Dây dẫn",
    children: ["Thay dây dẫn"]
  },
  {
    value: "Hỏng đèn cảnh báo",
    children: ["Thay đèn"]
  },
  {
    value: "Hỏng nút bấm",
    children: ["Thay nút bấm"]
  },
  {
    value: "Hỏng thiết bị trong tủ điện",
    children: ["Thay thiết bị"]
  },
  {
    value: "Hỏng chân",
    children: ["Thay chân"]
  },
  {
    value: "Hỏng khung",
    children: ["Thay khung"]
  },
  {
    value: "Mất, hỏng Pom",
    children: ["Thay"]
  },
  {
    value: "Rỉ dầu, kêu",
    children: [
      "Nặng: Thay gioăng, phớt, thay dầu, thay động cơ, HGT...",
      "Nhẹ: Kiểm tra, thêm dầu"
    ]
  },
  {
    value: "Mất mạng",
    children: ["Báo INFRA xử lý"]
  },
  {
    value: "Không hoạt động",
    children: ["Bật lại scanner"]
  },
  {
    value: "Bung thành chắn",
    children: ["Lắp lại thành chắn"]
  },
  {
    value: "Bung thanh gia cố",
    children: ["Loại bỏ, gia cố thêm khung băng"]
  },
  {
    value: "Lăn Hỏng",
    children: ["Thay con lăn"]
  },
  {
    value: "Lăn Kêu",
    children: ["Bôi dầu, mỡ, căn chỉnh giảm kêu"]
  },
  {
    value: "Hỏng thân tang",
    children: ["Nặng: Báo NCC gia công/thay thế", "Nhẹ: Khắc phục - chạy lại"]
  },
  {
    value: "Hỏng cụm tăng chỉnh",
    children: ["Nặng: Báo NCC gia công/thay thế", "Nhẹ: Khắc phục - chạy lại"]
  },
  {
    value: "Hỏng trục",
    children: ["Khắc phục chạy lại, báo NCC gia công/thay thế"]
  },
  {
    value: "Hỏng vòng bi",
    children: [
      "Nặng: NCC thay vòng bi",
      "Nhẹ: Khắc phục tiếng kêu, bôi dầu mỡ, chạy lại"
    ]
  },
  {
    value: "Nhông hỏng",
    children: ["Thay nhông"]
  },
  {
    value: "Mòn nhông",
    children: ["Kiểm tra, điều chỉnh sử dụng lại"]
  },
  {
    value: "Tụt then",
    children: ["Thay then"]
  },

  {
    value: "Xích trùng",
    children: ["Căng lại xích"]
  },
  {
    value: "Tuột xích",
    children: ["Lắp lại xích"]
  },
  {
    value: "Xích đứt",
    children: ["Thay xích"]
  },
  {
    value: "Khô mỡ",
    children: ["Thêm mỡ, dầu"]
  },
  {
    value: "Rách Belt",
    children: [
      "Nặng: Thay belt, nối lại belt",
      "Nhẹ: Khăc phục, chạy tiếp - theo dõi"
    ]
  },
  {
    value: "Hỏng mối nối",
    children: [
      "Nặng: NCC làm lại mối nối",
      "Nhẹ: Khăc phục, chạy tiếp - theo dõi"
    ]
  },
  {
    value: "Tấm Pom bung ra, cong, vênh",
    children: ["Chỉnh lại"]
  },
  {
    value: "Lệch/trùng belt",
    children: ["Căn chỉnh lại belt"]
  },
  {
    value: "Quá tải",
    children: ["Hướng dẫn VH, điều chỉnh, chạy lại"]
  },
  {
    value: "Điện kho",
    children: ["Nhẹ: Khắc phục chạy lại", "Hành chính báo NCC sửa"]
  },
  {
    value: "Dừng khẩn cấp",
    children: ["Kiểm tra, đánh giá, điều chỉnh, chạy lại"]
  },
  {
    value: "Kẹt hàng",
    children: ["Gỡ hàng - chạy lại"]
  },
  {
    value: "Gối ổ kêu - khô dầu",
    children: ["Thêm dầu, mỡ, theo dõi thêm"]
  },
  {
    value: "Hỏng gối ổ",
    children: ["NCC thay gối ổ"]
  },
  {
    value: "Tăng chỉnh độ trùng",
    children: ["Tăng chỉnh lại động cơ"]
  },
  {
    value: "Bung mối hàn",
    children: ["Hàn lại"]
  }
];

export const LEGO_ERROR_LOG = [
  "error_detail",
  "error_level",
  "error_specific",
  "error_type",
  "problem_solution",
  "resolution_time",
  "spent_time",
  "note",
  "executor"
];

export const LEGO_ERROR_LOG_TEXT = {
  error_detail: "Lỗi chi tiết",
  error_level: "Mức độ lỗi",
  error_specific: "Chi tiết thuộc",
  error_type: "Loại lỗi",
  problem_solution: "Phương án xử lý",
  resolution_time: "Thời gian giải quyết xong lỗi",
  spent_time: "Thời gian giải quyết lỗi",
  note: "Ghi chú lỗi",
  executor: "Người thực hiện / follow"
};

export const USER_AUTO_SORTING = [
  "baonhd2",
  "cuonght18",
  "daict5",
  "dungnd95",
  "dungnt262",
  "dungtv90",
  "haonn44",
  "minhlv18",
  "namdv11",
  "phuongnd81",
  "sontv22",
  "thanhnv446",
  "thientv8",
  "thinhnh29",
  "thopd12",
  "toannv175",
  "tuanva37"
];

export const CROSSBELT_ERROR = [
  {
    value: "Điện - WMS - WCS",
    label: "Điện - WMS - WCS"
  },
  {
    value: "Cơ khí",
    label: "Cơ khí"
  },
  {
    value: "Các lỗi khác",
    label: "Các lỗi khác"
  }
];

export const CROSSBELT_ERROR_TYPE = [
  {
    value: "Điện - WMS - WCS",
    children: ["Scanner", "Dừng dây chuyền", "Chi tiết khác"]
  },
  {
    value: "Cơ khí",
    children: [
      "Máng chia",
      "Đầu cấp",
      "Carrier",
      "Kết cấu: khung đỡ, cầu thang, sàn, tay vịn...",
      "Chổi than"
    ]
  }
];

export const CROSSBELT_ERROR_SPECIFIC = [
  {
    value: "Scanner",
    children: ["Mất kết nối", "Hỏng scanner"]
  },
  {
    value: "Chi tiết khác",
    children: [
      "Lỗi kịch bản",
      "Dừng khẩn cấp",
      "Sensor",
      "Lỗi kết nối",
      "Tủ điện, đèn báo...",
      "Chia sai, chia chậm, không chia..."
    ]
  },
  {
    value: "Dừng dây chuyền",
    children: ["Kẹt hàng"]
  },
  {
    value: "Máng chia",
    children: [
      "Thành cơ khí máng chia",
      "Bảng tên, các thiết bị khác",
      "Máng chứa hàng",
      "Cảm biến - Gương"
    ]
  },
  {
    value: "Đầu cấp",
    children: [
      "Dây curoa",
      "Lỗi nhập làn",
      "Tang",
      "Cảm biến",
      "Động cơ",
      "Biến tần",
      "Nút bấm"
    ]
  },
  {
    value: "Carrier",
    children: ["Hỏng, gãy xe carrier", "Lỗi xe carrier"]
  },
  {
    value: "Kết cấu: khung đỡ, cầu thang, sàn, tay vịn...",
    children: ["Hỏng", "Lệch vị trí, yếu, rung, lắc"]
  },
  {
    value: "Chổi than",
    children: ["Mòn chổi than", "Hỏng chổi than"]
  }
];

export const CROSSBELT_ERROR_DETAIL = [
  {
    value: "Mất kết nối",
    children: ["Kiểm tra kết nối - xử lý chạy lại"]
  },
  {
    value: "Hỏng scanner",
    children: ["Thay scanner"]
  },
  {
    value: "Lỗi kịch bản",
    children: ["Kiểm tra kịch bản, kết nối, chạy lại"]
  },
  {
    value: "Dừng khẩn cấp",
    children: ["Kiểm tra vấn đề dừng khẩn cấp, bỏ dừng, chạy lại"]
  },
  {
    value: "Sensor",
    children: ["Nặng: Hỏng - thay", "Nhẹ: Kiểm tra sensor - chạy lại"]
  },
  {
    value: "Lỗi kết nối",
    children: ["Kiểm tra kết nối, chạy lại"]
  },
  {
    value: "Tủ điện, đèn báo...",
    children: ["Nặng: Thay thiết bị", "Nhẹ: Kiểm tra, chạy lại"]
  },
  {
    value: "Chia sai, chia chậm, không chia...",
    children: ["Kiểm tra đánh giá lỗi, chạy lại"]
  },

  {
    value: "Kẹt hàng",
    children: ["Gỡ hàng - chạy lại"]
  },
  {
    value: "Thành cơ khí máng chia",
    children: ["Nhẹ: Khắc phục lại, hàn lại, bắt bulong lại..."]
  },
  {
    value: "Bảng tên, các thiết bị khác",
    children: ["Kiểm tra, thay thế"]
  },

  {
    value: "Máng chứa hàng",
    children: ["Nặng: Thay thế", "Nhẹ: Khắc phục, sử dụng lại"]
  },
  {
    value: "Cảm biến - Gương",
    children: ["Nặng: Thay thế", "Nhẹ: Khắc phục, sử dụng lại"]
  },
  {
    value: "Dây curoa",
    children: ["Nặng: thay mới", "Nhẹ: căng lại, chạy lại đầu cấp"]
  },
  {
    value: "Lỗi nhập làn",
    children: ["Kiểm tra nguyên nhân, chạy lại"]
  },
  {
    value: "Tang",
    children: ["Nhẹ: Bôi dầu mỡ, giảm kêu", "Thay tang dự phòng"]
  },
  {
    value: "Cảm biến",
    children: ["Nặng: Thay cảm biến", "Nhẹ: Kiểm tra kết nối, chạy lại"]
  },
  {
    value: "Động cơ",
    children: ["Nặng: Thay động cơ", "Nhẹ: Kiểm tra, khắc phục chạy lại"]
  },
  {
    value: "Biến tần",
    children: ["Nặng: Thay biến tần", "Nhẹ: Kiểm tra, khắc phục chạy lại"]
  },
  {
    value: "Nút bấm",
    children: ["Nặng: Thay nút bấm", "Nhẹ: Kiểm tra, chạy lại"]
  },
  {
    value: "Hỏng, gãy xe carrier",
    children: ["Thay mới thiết bị spare"]
  },
  {
    value: "Lỗi xe carrier",
    children: ["Căn chỉnh, chạy lại"]
  },
  {
    value: "Hỏng",
    children: ["Làm mới"]
  },
  {
    value: "Lệch vị trí, yếu, rung, lắc",
    children: ["Điều chỉnh lại"]
  },
  {
    value: "Mòn chổi than",
    children: ["Điều chỉnh chạy lại"]
  },
  {
    value: "Hỏng chổi than",
    children: ["Thay chổi than"]
  }
];

export const CHUTE_ERROR = [
  {
    value: "Cơ khí",
    label: "Cơ khí"
  },
  {
    value: "Các lỗi khác",
    label: "Các lỗi khác"
  }
];

export const CHUTE_ERROR_TYPE = [
  {
    value: "Cơ khí",
    children: ["Máng chia"]
  }
];

export const CHUTE_ERROR_SPECIFIC = [
  {
    value: "Máng chia",
    children: [
      "Thành cơ khí máng chia",
      "Bảng tên, các thiết bị khác",
      "Máng chứa hàng",
      "Cảm biến - Gương"
    ]
  }
];

export const CHUTE_ERROR_DETAIL = [
  {
    value: "Thành cơ khí máng chia",
    children: ["Nhẹ: Khắc phục lại, hàn lại, bắt bulong lại..."]
  },
  {
    value: "Bảng tên, các thiết bị khác",
    children: ["Kiểm tra, thay thế"]
  },
  {
    value: "Máng chứa hàng",
    children: ["Nặng: Thay thế", "Nhẹ: Khắc phục, sử dụng lại"]
  },
  {
    value: "Cảm biến - Gương",
    children: ["Nặng: Thay thế", "Nhẹ: Khắc phục, sử dụng lại"]
  }
];

export const AUTO_SORTING_TAG_NAME = {
  CONVEYOR: "Băng tải",
  LEGO_CHUTE: "Máng chia",
  CABINET: "Tủ điện",
  BOMBAY: "BOMBAY",
  CROSSBELT: "CROSSBELT",
  WHEEL_SORTER: "WHEEL_SORTER",
  ARM_SORTER: "ARM_SORTER",
  OTHER_SORTING: "OTHER_SORTING"
};

export const CABINET_ERROR = [
  {
    value: "Điện - WMS - WCS - Động cơ - Biến tần",
    label: "Điện - WMS - WCS - Động cơ - Biến tần"
  },
  {
    value: "Các lỗi khác",
    label: "Các lỗi khác"
  }
];

export const CABINET_ERROR_TYPE = [
  {
    value: "Điện - WMS - WCS - Động cơ - Biến tần",
    children: ["Tủ điện"]
  }
];

export const CABINET_ERROR_SPECIFIC = [
  {
    value: "Tủ điện",
    children: [
      "Dây dẫn",
      "Hỏng đèn cảnh báo",
      "Hỏng nút bấm",
      "Hỏng thiết bị trong tủ điện"
    ]
  }
];

export const CABINET_ERROR_DETAIL = [
  {
    value: "Dây dẫn",
    children: ["Thay dây dẫn"]
  },
  {
    value: "Hỏng đèn cảnh báo",
    children: ["Thay đèn"]
  },
  {
    value: "Hỏng nút bấm",
    children: ["Thay nút bấm"]
  },
  {
    value: "Hỏng thiết bị trong tủ điện",
    children: ["Thay thiết bị"]
  }
];

export const SMARTLOCK_CAMERA_STATUS = {
  1: {
    id: "1",
    name: "Online",
    color: "#069255"
  },
  0: {
    id: "0",
    name: "Offline",
    color: "#b5b5c3"
  }
};

export const DEVICE_TYPE = [
  {
    label: "Băng tải",
    value: "conveyor"
  },
  {
    label: "Bombay",
    value: "bombay"
  },
  {
    label: "Crossbelt",
    value: "crossbelt"
  },
  {
    label: "Flash scanner",
    value: "Flash scanner"
  },
  {
    label: "Telescopic",
    value: "telescopic"
  },
  {
    label: "Wheel",
    value: "wheel"
  }
];

export const UNIT_TYPE = {
  YEAR: "Năm",
  MONTH: "Tháng",
  DAY: "Ngày",
  HOUR: "Giờ",
  MINUTE: "Phút",
  SECOND: "Giây"
};

export const CHECKLIST_STATUS_BADGE = {
  FINISHED: {
    type: "success",
    color: "#CAF1D8",
    label: "Đã kết thúc"
  },
  STARTED: {
    type: "processing",
    color: "#D0E1FD",
    label: "Đã bắt đầu"
  },
  UNASSIGNED: {
    type: "default",
    color: "gray",
    label: "Chưa phân công"
  },
  ASSIGNED: {
    type: "warning",
    color: "#FFF8F3",
    label: "Đã phân công"
  },
  WAIT_START: {
    type: "default",
    color: "#gray",
    label: "Chưa bắt đầu"
  },
  NOT_FINISHED: {
    type: "error",
    color: "#ff4d4f",
    label: "Chưa hoàn thành"
  }
};

export const SOURCE_REPORT = [
  {
    label: "Hệ thống",
    value: "SYSTEM"
  },
  {
    label: "KTV IoT",
    value: "KTV"
  },
  {
    label: "Vận hành",
    value: "OPERATORS"
  },
  {
    label: "Infra, HC, ...",
    value: "INFRA_HC"
  },
  {
    label: "Khác",
    value: "OTHER"
  }
];

export const INCIDENT_CAUSE = [
  {
    label: "IOT",
    value: "IOT"
  },
  {
    label: "Vận hành",
    value: "OPERATORS"
  },
  {
    label: "NCC",
    value: "SUPPLIER"
  },
  {
    label: "Infra, HC, ...",
    value: "INFRA_HC"
  },
  {
    label: "Lỗi khách quan",
    value: "OBJECTIVE"
  },
  {
    label: "Khác",
    value: "OTHER"
  }
];

export const INCIDENT_LEVEL = [
  {
    label: "Urgent",
    value: "URGENT"
  },
  {
    label: "High",
    value: "HIGH"
  },
  {
    label: "Medium",
    value: "MEDIUM"
  },
  {
    label: "Low",
    value: "LOW"
  }
];

export const TECHNICIAN_STATUS_V3 = [
  {
    label: "DOING",
    value: "DOING"
  },
  {
    label: "DONE",
    value: "DONE"
  }
];

export const INCIDENT_PRIORITY_LEVEL = {
  0: {
    label: "Low",
    value: "LOW"
  },
  50: {
    label: "Medium",
    value: "MEDIUM"
  },
  80: {
    label: "High",
    value: "HIGH"
  },
  100: {
    label: "Urgent",
    value: "URGENT"
  }
};

export const TECHNICIAN_STATUS = [
  {
    label: "OPEN",
    value: "OPEN"
  },
  {
    label: "DOING",
    value: "DOING"
  },
  {
    label: "CLOSED",
    value: "CLOSED"
  },
  {
    label: "CANCEL",
    value: "CANCEL"
  }
];
export const TECHNICIAN_STATUS_V2 = [
  {
    label: "CLOSED",
    value: "CLOSED"
  },
  {
    label: "DONE",
    value: "DONE"
  }
];

export const TECHNICIAN_STATUS_BADGE = {
  OPEN: {
    type: "warning",
    label: "Chưa bắt đầu"
  },
  DOING: {
    type: "processing",
    label: "Đang xử lý"
  },
  CANCEL: {
    type: "default",
    label: "Cancel"
  },
  DONE: {
    type: "success",
    label: "Hoàn thành"
  },
  CLOSED: {
    type: "success",
    label: "Hoàn thành"
  },
  SYSTEM: {
    label: "Hệ thống"
  },
  KTV: {
    label: "KTV IoT"
  },
  OPERATORS: {
    label: "Vận hành"
  },
  INFRA_HC: {
    label: "Infra, HC, ...",
    value: "INFRA_HC"
  },
  OTHER: {
    label: "Khác",
    value: "OTHER"
  },
  IOT: {
    label: "IOT",
    value: "IOT"
  },
  SUPPLIER: {
    label: "NCC",
    value: "SUPPLIER"
  },
  OBJECTIVE: {
    label: "Lỗi khách quan",
    value: "OBJECTIVE"
  },
  UNASSIGNED: {
    type: "default",
    label: "Chưa phân công"
  },
  PAST_DUE: {
    type: "error",
    label: "Quá hạn"
  },
  TEMPORARY_FIX: {
    type: "warning",
    label: "Đã khắc phục tạm thời"
  },
  TROUBLESHOOTED: {
    type: "success",
    label: "Đã khắc phục hoàn toàn"
  },
  VERIFYING: {
    type: "processing",
    label: "Verifying"
  },
  NEW: {
    type: "error",
    label: "Báo lỗi"
  }
};

export const CHECKLIST_TIME_UNIT = [
  {
    value: "SECOND",
    label: "Giây"
  },
  {
    value: "MINUTE",
    label: "Phút"
  },
  {
    value: "HOUR",
    label: "Giờ"
  },
  {
    value: "DAY",
    label: "Ngày"
  },
  {
    value: "MONTH",
    label: "Tháng"
  },
  {
    value: "YEAR",
    label: "Năm"
  }
];

export const CHANNEL_ID_NAME = {
  "8639165179335649921": "Tech - Vận hành Bình Xuyên",
  "1890565850150291526": "Tech - Vận hành Đài Tư",
  "499252174779761545": "Tech - Vận hành Tân Phú Trung",
  "4864277602981207001": "Tech - Vận hành Gò Vấp",
  "2584522218920413985": "Tech - Vận hành Yên Nghĩa",
  "8847440154652649495": "Tech - Vận hành kho liên vùng"
};

export default function useEventListener(
  eventType,
  callback,
  element = window
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (element == null) return;
    const handler = e => callbackRef.current(e);
    element.addEventListener(eventType, handler);

    return () => element.removeEventListener(eventType, handler);
  }, [eventType, element]);
}

export const TICKET_STATUS_LEVEL = {
  NEW: 0,
  DOING: 10,
  NO_RESPONSE: 11,
  BROKEN: 12,
  TEMPORARY_FIX: 20,
  TROUBLESHOOTED: 30,
  VERIFYING: 40,
  CLOSED: 50,
  CANCELLED: 100
};

export const TICKET_STATUS_TITLE = {
  0: "New",
  10: "Đang xử lý",
  11: "Không phản hồi",
  12: "Hỏng, chờ linh kiện",
  20: "Đã khắc phục tạm thời",
  30: "Đã khắc phục hoàn toàn",
  40: "Verifying",
  50: "Closed",
  98: "Urgent",
  99: "Quá hạn",
  100: "Không phải lỗi"
};

export const TAG_TICKET_STATUS_COLOR = {
  0: {
    color: "#FF2A04",
    label: "Báo lỗi"
  },
  10: {
    color: "#FFAF3D",
    label: "Đang xử lý"
  },
  11: {
    color: "#FFAF3D",
    label: "Không phản hồi"
  },
  12: {
    color: "#FFAF3D",
    label: "Hỏng, chờ linh kiện"
  },
  20: {
    color: "#FAD800",
    label: "Đã khắc phục tạm thời"
  },
  30: {
    color: "success",
    label: "Đã khắc phục hoàn toàn"
  },
  40: {
    color: "blue",
    label: "Verifying"
  },
  50: {
    color: "success",
    label: "Closed"
  },
  98: {
    color: "#DA5149",
    label: "Urgent"
  },
  99: {
    color: "#FD0000",
    label: "Quá hạn"
  },
  100: {
    color: "grey",
    label: "Không phải lỗi"
  }
};

export const SUPPLIER_TASK_TYPE = {
  SHIFT_BEGIN: "Kiểm tra hàng ngày",
  PERIODIC: "Bảo dưỡng định kỳ",
  INCIDENT: "Sự cố",
  REPAIR: "Sửa chữa",
  NEW_IMPLEMENTATION: "Triển khai mới",
  INNOVATION: "Cải tiến"
};

export const INCIDENT_TYPES = [
  { label: "Truyền thông", value: "COMMUNICATIVE" },
  { label: "Điện tử", value: "ELECTRONIC" },
  { label: "Cơ", value: "MECHANICAL" },
  { label: "Điện", value: "ELECTRICAL" }
];
